import { IGetHeadingOptions } from './types'

export const getHeadingOptions: IGetHeadingOptions = (title, subtitle) => {
  return subtitle ? { h2: title, h3: subtitle } : { h2: title }
}
